import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const tableColumns = [
        {
            label: "菜单名称",
            prop: "name",
            width: '300px',
            show: true,
            align: 'left'
        },
        {
            label: "排序",
            prop: "sort",
            align: "center",
            show: true
        },
        {
            label: "显示图标",
            prop: "icon",
            align: "center",
            show: true
        },
        {
            label: "菜单URL",
            prop: "url",
            align: "center",
            show: true
        },
        // {
        //     label: "权限标识",
        //     prop: "perms",
        //     align: "center",
        //     show: true
        // },
        {
            label: "平台标识",
            prop: "platform",
            align: "center",
            show: true
        },
        {
            label: "学生端菜单标识",
            prop: "flag",
            align: "center",
            show: true
        },
    ]

    const formItems = [
        {
            label: "菜单名称",
            span: 24,
            placeholder: '请输入菜单名称',
            model: "name",
            labelWidth: '150px',
        },
        {
            label: "菜单URL",
            span: 24,
            placeholder: '请输入菜单URL',
            model: "url",
            labelWidth: '150px',
        },
        {
            label: "菜单组件",
            span: 24,
            placeholder: '请输入菜单组件',
            model: "component",
            labelWidth: '150px',
        },
        {
            label: "权限标识",
            span: 24,
            placeholder: '请输入权限标识',
            model: "perms",
            labelWidth: '150px',
        },
        {
            label: "平台标识",
            span: 24,
            placeholder: '请输入平台标识',
            model: "platform",
            labelWidth: '150px',
        },
        {
            label: "图标",
            span: 24,
            placeholder: '请输入图标',
            model: "icon",
            labelWidth: '150px',
        },
        // {
        //     label: "菜单层级",
        //     span: 24,
        //     model: "level",
        //     type: 'number',
        //     labelWidth: '150px',
        //     placeholder: '请输入菜单层级',
        // },
        {
            label: "排序",
            span: 24,
            type: 'number',
            placeholder: '请输入排序',
            model: "sort",
            min: 0,
            labelWidth: '150px',
        },
        {
            label: "是否启用",
            span: 24,
            type: 'radio',
            placeholder: '请选择',
            model: "isDelete",
            options: [
                { label: '启用', value: "0" },
                { label: '停用', value: "1" }
            ],
            labelWidth: '150px',
        },
        {
            label: "是否缓存",
            span: 24,
            type: 'radio',
            placeholder: '请选择',
            model: "isAlive",
            options: dic._IS,
            labelWidth: '150px',
        },
    ]

    const formRules = {
        name: [{
            required: true,
            message: "请输入菜单名称",
            trigger: "blur"
        }],
        url: [{
            required: true,
            message: "请输入菜单URL",
            trigger: "blur"
        }],
        component: [{
            required: true,
            message: "请输入菜单组件",
            trigger: "blur"
        }],
        sort: [{
            required: true,
            message: "请输入排序",
            trigger: "blur"
        }],
        platform: [{
            required: true,
            message: "请输入平台标识",
            trigger: "blur"
        }],
        isAlive: [{
            required: true,
            message: "请选择",
            trigger: "change"
        }],
    }
    const formItems_setting = [
        {
            label: "学生端菜单标识",
            span: 24,
            placeholder: '请选择',
            model: "flag",
            type: 'select',
            options: dic._MENUFLAG,
            multiple:true,
        }]

    const formRules_setting = {
        flag: [{
            required: true,
            message: "请选择菜单标识",
            trigger: "blur"
        }],
    }
    const tree = {
        props: {
            parent: "parentId", // 父级唯一标识
            value: "id", // 唯一标识
            label: "name", // 标签显示
            children: "children" // 子级
        }
    }

    const types = [
        {
            label: "目录",
            type: "default",
            value: 0
        },
        {
            label: "菜单",
            type: "success",
            value: 1
        },
        {
            label: "按钮",
            type: "info",
            value: 2
        }
    ]

    return {
        tableColumns,
        formItems,
        formRules,
        formItems_setting,
        formRules_setting,
        tree,
        types,
    }
}